type ActivityCallback = () => void;
let _onActivityCallback: ActivityCallback | null = null;

export const SessionHub = {
    registerTracker(callback: ActivityCallback) {
        _onActivityCallback = callback;
    },

    triggerActivityPulse() {
        if (_onActivityCallback) {
            _onActivityCallback();
        }
    },

    logToCloud(prefix: string, logObj: unknown): void {
        const cleanJson = JSON.stringify(logObj, (key: string, value: unknown) => {
            // Handle stack traces smartly
            if (key === 'stack' && typeof value === 'string') {
                const lines = value.split('\n');
                const maxLines = 4; // Error message + top 3 code execution steps

                if (lines.length > maxLines) {
                    // Lean newline truncation indicator
                    return lines.slice(0, maxLines).join('\n') + '\n[...]';
                }
                return value;
            }

            // General truncation rule for tokens and other long strings
            if (typeof value === 'string' && value.length > 50) {
                // Lean string truncation indicator
                return value.slice(0, 50) + "[...]";
            }

            return value;
        });

        const toLog = `Suite: ${prefix}: ${cleanJson}`;
        const cloudRunUrl = "https://cloud-logger-990840206620.me-west1.run.app/logme";

        fetch(cloudRunUrl, {
            method: "POST",
            headers: { "Content-Type": "text/plain" },
            body: toLog,
            keepalive: true
        }).catch(() => {});
    }
};